import * as React from 'react';
import { v4 as uuidGenerator } from 'uuid';
import { UeContainer, UeReference } from '@oneaudi/falcon-tools';
import { StyleSocialLinkLayout } from './style';
import { IconButton } from '@oneaudi/unified-web-components';

export type SocialMediaConfig = {
  facebook: string;
  facebookUrl?: string;
  instagram: string;
  instagramUrl: string;
  twitter: string;
  twitterUrl: string;
  linkedln: string;
  linkedlnUrl: string;
  youtube: string;
  youtubeUrl: string;
  vimeo: string;
  vimeoUrl: string;
}[];

export type SocialBarProps = {
  socialMedia: SocialMediaConfig;
};

export const SocialMediaBar = ({ socialMedia }: SocialBarProps): React.ReactElement => {
  return (
    <UeContainer propertyPath="variantConfig_socialMedia" label="Social Media">
      <StyleSocialLinkLayout data-testid="social-layout">
        {socialMedia.map((socialMediaLinkInfo, index: number) => {
          return (
            <React.Fragment key={uuidGenerator()}>
              {socialMediaLinkInfo.facebook ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    size="md"
                    href={socialMediaLinkInfo?.facebookUrl || ''}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    icon="facebook"
                    aria-label="facebook"
                    variant="tertiary"
                    data-testid="facebook-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.instagram ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.instagramUrl}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    className="arrow"
                    icon="instagram"
                    aria-label="instagram"
                    data-testid="instagram-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.twitter ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.twitterUrl}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    icon="x"
                    aria-label="x"
                    data-testid="x-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.linkedln ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.linkedlnUrl}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    icon="linkedin"
                    aria-label="linkedin"
                    data-testid="linkedin-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.youtube ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.youtubeUrl}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    icon="youtube"
                    aria-label="youtube"
                    data-testid="youtube-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
              {socialMediaLinkInfo.vimeo ? (
                <UeReference propertyPath={`variantConfig_socialMedia.${index}`}>
                  <IconButton
                    variant="tertiary"
                    size="md"
                    href={socialMediaLinkInfo.vimeoUrl}
                    // margin={['var(--spacing-relative-md)', 0, 0, 0]}
                    target="_blank"
                    icon="vimeo"
                    aria-label="vimeo"
                    data-testid="vimeo-icon"
                    data-test-type="social-button"
                  />
                </UeReference>
              ) : (
                ''
              )}
            </React.Fragment>
          );
        })}
      </StyleSocialLinkLayout>
    </UeContainer>
  );
};
